export default [
  {
    title: 'Amazon Attribution',
    channel: 'amazon-ads',
    icon: { icon: 'mdi:link-variant' },
    badgeContent: 'Preview',
    badgeClass: 'bg-primary',
    children: [
      {
        title: 'Performance',
        action: 'read',
        subject: 'User',
        to: 'attribution-analytics',
        icon: { icon: 'mdi:chart-timeline-variant' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Products',
        action: 'read',
        subject: 'User',
        to: 'attribution-products',
        icon: { icon: 'mdi:package-variant-closed' },
        isNeedBusinessProfile: true,
      },
      {
        // No `isNeedBusinessProfile` here, matching the AI Integration group's How-to:
        // the help page is the launch surface for a tenant with nothing set up yet,
        // so it must stay reachable before a business profile exists.
        title: 'How-to',
        action: 'read',
        subject: 'Management',
        to: 'attribution-how-to',
        icon: { icon: 'mdi-book-open-page-variant-outline' },
      },
    ],
  },
];
